import styled from "styled-components";

export const AllNotificationsWrapper = styled.div`
    display: flex;
    width: 100%;
    background-color: var(--white);
    box-shadow: 0px 0px 5px rgba(0, 0, 0, .1);
    border-radius: 10px;
    flex-wrap: wrap;
    .notifyHeader{
        display: flex;
        width: 100%;
        border-bottom: 1px solid var(--border);
        align-items: center;
        padding: 14px 16px;
        gap: 16px;
        & > div{
            padding-top: 3px;
        }
        body.rtl &{
            svg{
                transform: scaleX(-1);
            }
            
        }
    }
`